import { useEffect, useState, ReactNode, useContext } from "react";
import { Box, Typography, IconButton, Paper } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate, useLocation } from "react-router-dom";
// components
import Notification from "src/components/UI/Shared/Notification";
import user from "src/components/UI/Shared/user";
import { HeaderSimple } from "src/layouts/_common";
// config
import { RESPONSE_STATUS } from "src/config/service";
// styles
import styles from "src/layouts/assets/scss/identity-layout.module.scss";
// redux
import { useSelector, useDispatch } from "react-redux";
import { appActions } from "src/store/store";

type Props = {
  children: ReactNode;
};

const IdentityLayout = ({ children }: Props) => {
  const dispatch = useDispatch();
  const notification = useSelector((state: any) => state.app.Notification);
  const trackingData = useSelector((state: any) => state.app.trackingData);
  const mobileMode = useSelector((state: any) => state.app.mobileMode);

  const navigate = useNavigate();
  const { pathname } = useLocation();

  const [header, setHeader] = useState("");
  const [signOut, setSignOut] = useState(false);

  const currentPathHead = pathname.split("/").slice(-1)[0];
  const currentComponent =
    currentPathHead === "login"
      ? "Sign in"
      : currentPathHead === "lock"
      ? "Lock Screen"
      : currentPathHead === "register"
      ? "Sign up"
      : currentPathHead === "payment"
      ? "Purchase Credits"
      : "";

  const handleCloseAll = () => {
    dispatch(appActions.setPreviousNavigation("/Geo"));
    navigate("/");
    if (signOut) {
      user.signOut();
    }
  };
  const urlParams = new URLSearchParams(window.location.search);
  const optionalParamValue = urlParams.get("reset");
  useEffect(() => {
    if (optionalParamValue)
      dispatch(appActions.setOptionalParam(optionalParamValue));
  }, [optionalParamValue]);
  useEffect(() => {
    setHeader(currentComponent);
    setSignOut(currentPathHead === "lock");
  }, [pathname]);
  useEffect(() => {
    if (trackingData.serviceStatus === RESPONSE_STATUS.VERIFY) {
      navigate("../../verify");
    }
  }, [trackingData.serviceStatus]);
  useEffect(() => {
    if (window.innerWidth < 600) dispatch(appActions.setMobileMode(true));
    else dispatch(appActions.setMobileMode(false));
  }, []);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 600) dispatch(appActions.setMobileMode(true));
      else dispatch(appActions.setMobileMode(false));
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <>
      <div className={styles.root}>
        {!mobileMode ? (
          <div
            className={styles.logoDevBlack}
            onClick={() => navigate("/")}
            style={{ cursor: "pointer" }}
          />
        ) : (
          <HeaderSimple
            inHome={currentPathHead === ""}
            onClosePickerMode={() => {}}
          />
        )}

        <Box className={styles.box}>
          {currentComponent && (
            <Paper className={styles.header}>
              <Typography
                className={styles.headerText}
                variant="h1"
                component="h1"
              >
                {header}
              </Typography>
            </Paper>
          )}

          <IconButton
            className={styles.iconButton}
            disableRipple
            aria-label="Close"
            onClick={handleCloseAll}
          >
            <CloseIcon
              sx={{ fontSize: "1rem", color: "#c3e7ff75", fontWeight: "900" }}
            />
          </IconButton>
          {children}
        </Box>
      </div>
      {notification.open && <Notification />}
    </>
  );
};
export default IdentityLayout;
